import { REQUIREMENTS } from '../constants';
import Item from '../Item';

const Requirements = () => (
  <>
    <h3 className="font-subtitle3 w-full text-left mb-16">Requisitos:</h3>
    <p className="font-body4 mb-16">
      Toda persona interesada en aplicar al beneficio, tendrá que cumplir a
      cabalidad con los siguientes requisitos, sin excepción alguna:
    </p>
    <ul className="mb-32">
      {REQUIREMENTS.map(({ paragraph, shouldParser }) => (
        <Item
          paragraph={paragraph}
          shouldParser={shouldParser}
          key={paragraph.slice(0, 7).replace(' ', '_')}
        />
      ))}
    </ul>
  </>
);

export default Requirements;
